import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminFeatureFlags } from "@/lib/query/core/invalidation";

export function useDeleteFeatureFlagMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: string) =>
      apiJsonClient<void>(endpoints.admin.featureFlagById(id), {
        method: "DELETE",
      }),
    onSuccess: async () => {
      await invalidateAdminFeatureFlags(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
